import '../scss/app.scss'
import './global-imports.js'
import '../plugins/bootstrap/bootstrap.js'

// selective import of components
import 'flatpickr'
import select2 from 'select2'
select2();
import 'bootstrap-maxlength';
import '../plugins/glyph-alerts/admin/toasts/basic-toast-alert.js'
import '../plugins/glyph-alerts/admin/toasts/notyf-alert.js'
import '../plugins/seo-snippet/snippet-preview.js'
import '../plugins/cropper/cropper.js'
import '../plugins/glyph-expandable-columns/glyph-expandable-columns.js'
import '../plugins/glyph_copy_to_clipboard/glyph_copy_to_clipboard.js'
import '../plugins/glyph_text_formatter/glyph_text_formatter.js'
import GlyphSortable from "../plugins/glyph-sortable/glyph-sortable.js";
window.GlyphSortable = GlyphSortable;
import {MM_jumpMenu, makeseo} from './functions.js';
window.makeseo = makeseo;
window.MM_jumpMenu = MM_jumpMenu;
import './sidebar.js'
import './auth-page.js'
import './two-steps.js'
import './two-factor-authentication.js'
import './features/aside.js'
import './tag-filters-module.js'
import './password-show.js'
import './cms-search.js'
import './offcanvas.js'
import './translations.js'
import './image-input.js'
import './glyph-cropper.js'
import TinyMCE from "./wysiwyg.js";
window.TinyMCE = TinyMCE;

import {initAjaxPagination} from "./pagination.js";
window.initAjaxPagination = initAjaxPagination;


import XEditable from './xeditable-loader.js';
window.XEditable = XEditable;

import GlyphTranslations from "./translations.js";
window.GlyphTranslations = GlyphTranslations;

import './dropzone-loader.js';
import Tagify from '@yaireo/tagify'
window.Tagify = Tagify;
import './remember-scroll-position.js'
window.loadApexCharts = async () => {
    const module = await import('./apexcharts-loader.js');
    return module.loadApexCharts();
};

import AutoComplete from "../plugins/autocomplete/autocomplete.js"
window.AutoComplete = AutoComplete;
